<script setup lang="ts">
import ContextMenuButton from '@/dashboard/vue/components/common/ContextMenu/ContextMenuButton.vue';
import DropdownTitleHover from '@/dashboard/vue/components/common/Dropdown/DropdownTitleHover.vue';
import LinkIcon from '@/dashboard/vue/components/icons/LinkIcon.vue';
import LockIcon from '@/dashboard/vue/components/icons/LockIcon.vue';
import TeamIcon from '@/dashboard/vue/components/icons/TeamIcon.vue';
import InfoIcon from '@/dashboard/vue/components/icons/InfoIcon.vue';
import VisibilityTypeLabel from '@/dashboard/vue/components/popups/VisibilityTypeLabel.vue';
import Dropdown from '@/dashboard/vue/components/common/Dropdown/Dropdown.vue';
import DropDownArrowIcon from '@/dashboard/vue/components/icons/DropdownArrowIcon.vue';
import { ProjectVisibility } from '@/dashboard/types/project_visibility';
import { UserRole } from '@/dashboard/types/user_role';
import Tooltip from '@/dashboard/vue/components/common/Tooltip.vue';
import AlertInfoIcon from '@/dashboard/vue/components/icons/AlertInfoIcon.vue';
import ProjectRoleTooltip from '@/dashboard/vue/components/tooltips/projectRoleTooltip.vue';

const props = defineProps<{
  canEdit: boolean;
  type: ProjectVisibility;
  showPrivate: boolean;
  setType?: (type: ProjectVisibility) => void;
}>();
</script>

<template>
  <div class="flex items-center gap-xs">
    <span class="text-caption-s text-gray-700">Privacy:</span>

    <Dropdown v-if="props.canEdit" body-class="mt-xxs z-[6001] gap-[2px] p-[6px]">
      <template #title="{ isOpen }: any">
        <DropdownTitleHover :is-active="isOpen">
          <div class="flex items-center gap-xs">
            <VisibilityTypeLabel :type="props.type" />
            <DropDownArrowIcon class="stroke-black dark:stroke-gray-500" />
          </div>
        </DropdownTitleHover>
      </template>
      <template #body>
        <ContextMenuButton v-if="props.showPrivate" :need-dark="true" :action="() => props.setType && props.setType('private')">
          <div class="flex items-center gap-[10px] whitespace-nowrap">
            <LockIcon stroke-class="stroke-black dark:stroke-white" fill-class="fill-black dark:fill-white" />
            <span class="text-caption-s text-black dark:text-white">Private</span>
            <Tooltip>
              <template #title>
                <InfoIcon class="cursor-pointer stroke-gray-400 dark:stroke-gray-650" />
              </template>
              <template #body>
                <ProjectRoleTooltip project-type="private" />
              </template>
            </Tooltip>
          </div>
        </ContextMenuButton>
        <ContextMenuButton :need-dark="true" :action="() => props.setType && props.setType('link')">
          <div class="flex items-center gap-[10px] whitespace-nowrap">
            <LinkIcon class="stroke-black dark:stroke-white" />
            <span class="text-caption-s text-black dark:text-white">Viewable via link</span>
            <Tooltip>
              <template #title>
                <InfoIcon class="cursor-pointer stroke-gray-400 dark:stroke-gray-650" />
              </template>
              <template #body>
                <ProjectRoleTooltip project-type="link" />
              </template>
            </Tooltip>
          </div>
        </ContextMenuButton>
        <ContextMenuButton :need-dark="true" :action="() => props.setType && props.setType('team')">
          <div class="flex items-center gap-[10px] whitespace-nowrap">
            <TeamIcon class="stroke-black dark:stroke-white" />
            <span class="text-caption-s text-black dark:text-white">Shared with the team</span>
            <Tooltip>
              <template #title>
                <InfoIcon class="cursor-pointer stroke-gray-400 dark:stroke-gray-650" />
              </template>
              <template #body>
                <ProjectRoleTooltip project-type="team" />
              </template>
            </Tooltip>
          </div>
        </ContextMenuButton>
      </template>
    </Dropdown>
    <VisibilityTypeLabel v-else :type="props.type" />

    <Tooltip>
      <template #title>
        <InfoIcon class="cursor-pointer stroke-gray-400 dark:stroke-gray-650" />
      </template>
      <template #body>
        <ProjectRoleTooltip :project-type="props.type" />
      </template>
    </Tooltip>
  </div>
</template>
